import { jsx as i, jsxs as l, Fragment as t } from "react/jsx-runtime";
import { Button as n } from "../Button/Button.js";
import "../Button/ButtonBase.js";
import "../Button/theme.js";
const a = (e) => /* @__PURE__ */ i("div", { className: "flex gap-2", children: !e.autoApply && /* @__PURE__ */ l(t, { children: [
  /* @__PURE__ */ i(n, { color: "outline", size: "sm", onClick: e.onCancel, children: "Cancel" }),
  /* @__PURE__ */ i(
    n,
    {
      size: "sm",
      color: "light",
      onClick: e.onConfirm,
      disabled: e.selecting === "end" || !e.tempStart && !e.tempEnd,
      children: "Apply"
    }
  )
] }) });
export {
  a as Actions
};
